$(document).ready(function () {
  $('.tabs input').click(function(event){
    $(this).siblings('input').removeAttr('checked')
    var id = $(this).attr('id');
    $('[data-toggle-show]').each(function(){
      var attribute = $(this).attr('data-toggle-show');
      (attribute === id) ? $(this).css('display','inline-block') : $(this).css('display','none');
    });
  });
});
